import type { MutationTree } from "vuex";
import type { ScenarioState, Scenario } from "@/types";
export const LOAD_SCENARIOS_BY_PLACE = "LOAD_SCENARIOS_BY_PLACE";
export const LOAD_SCENARIOS_BY_PLACE_SUCCESS =
  "LOAD_SCENARIOS_BY_PLACE_SUCCESS";
export const LOAD_SCENARIOS_BY_PLACE_FAILURE =
  "LOAD_SCENARIOS_BY_PLACE_FAILURE";

export const LOAD_SCENARIOS_BY_ID = "LOAD_SCENARIOS_BY_ID";
export const LOAD_SCENARIOS_BY_ID_SUCCESS = "LOAD_SCENARIOS_BY_ID_SUCCESS";
export const LOAD_SCENARIOS_BY_ID_FAILURE = "LOAD_SCENARIOS_BY_ID_FAILURE";

export const ADD_SCENARIO_BY_PLACE = "ADD_SCENARIO_BY_PLACE";
export const ADD_SCENARIO_SUCCESS_BY_PLACE = "ADD_SCENARIO_SUCCESS_BY_PLACE";
export const ADD_SCENARIO_FAILURE_BY_PLACE = "ADD_SCENARIO_FAILURE_BY_PLACE";

export const UPDATE_SCENARIO_BY_PLACE = "UPDATE_SCENARIO_BY_PLACE";
export const UPDATE_SCENARIO_SUCCESS_BY_PLACE =
  "UPDATE_SCENARIO_SUCCESS_BY_PLACE";
export const UPDATE_SCENARIO_FAILURE_BY_PLACE =
  "UPDATE_SCENARIO_FAILURE_BY_PLACE";

export const DELETE_SCENARIO_BY_PLACE = "DELETE_SCENARIO_BY_PLACE";
export const DELETE_SCENARIO_SUCCESS_BY_PLACE =
  "DELETE_SCENARIO_SUCCESS_BY_PLACE";
export const DELETE_SCENARIO_FAILURE_BY_PLACE =
  "DELETE_SCENARIO_FAILURE_BY_PLACE";

export const mutations: MutationTree<ScenarioState> = {
  //Load_SCENARIOS_BY_PLACE
  [LOAD_SCENARIOS_BY_PLACE](state: ScenarioState) {
    state.scenarios = { ...state.scenarios, loading: true, error: null };
  },
  [LOAD_SCENARIOS_BY_PLACE_SUCCESS](
    state: ScenarioState,
    scenarios: Scenario[],
  ) {
    state.scenarios = { data: scenarios, loading: false, error: null };
  },
  [LOAD_SCENARIOS_BY_PLACE_FAILURE](state: ScenarioState, error: string) {
    state.scenarios = {
      ...state.scenarios,
      loading: false,
      error: error,
    };
  },

  // LOAD_SCENARIOS_BY_ID
  [LOAD_SCENARIOS_BY_ID](state: ScenarioState) {
    state.scenariosByIDList = {
      ...state.scenarios,
      loading: true,
      error: null,
    };
  },
  [LOAD_SCENARIOS_BY_ID_SUCCESS](state: ScenarioState, scenarios: Scenario[]) {
    state.scenariosByIDList = { data: scenarios, loading: false, error: null };
  },

  [LOAD_SCENARIOS_BY_ID_FAILURE](state: ScenarioState, error: string) {
    state.scenariosByIDList = {
      ...state.scenarios,
      loading: false,
      error: error,
    };
  },

  //ADD_SCENARIOS
  [ADD_SCENARIO_BY_PLACE](state: ScenarioState) {
    state.scenario = { ...state.scenario, loading: true, error: null };
  },
  [ADD_SCENARIO_SUCCESS_BY_PLACE](state: ScenarioState, scenario: Scenario) {
    state.scenario = {
      data: scenario,
      loading: false,
      error: null,
    };
    state.scenarios = {
      data: [...state.scenarios.data, ...[scenario]],
      loading: false,
      error: null,
    };
  },
  [ADD_SCENARIO_FAILURE_BY_PLACE](state: ScenarioState, error: string) {
    state.scenario = {
      ...state.scenario,
      loading: false,
      error: error,
    };
  },
  //UPDATE_SCENARIO
  [UPDATE_SCENARIO_BY_PLACE](state: ScenarioState) {
    state.scenario = { ...state.scenario, loading: true, error: null };
  },
  [UPDATE_SCENARIO_SUCCESS_BY_PLACE](state: ScenarioState, scenario: Scenario) {
    state.scenario = {
      data: { ...scenario, updated: true },
      loading: false,
      error: null,
    };
    state.scenarios.data[
      state.scenarios.data.findIndex((sc: Scenario) => sc.id === scenario.id)
    ] = scenario;
  },
  [UPDATE_SCENARIO_FAILURE_BY_PLACE](state: ScenarioState, error: string) {
    state.scenario = {
      ...state.scenario,
      loading: false,
      error: error,
    };
  },

  // DELETE_SCENARIO
  [DELETE_SCENARIO_BY_PLACE](state: ScenarioState) {
    state.scenarios = { ...state.scenarios, loading: true, error: null };
  },
  [DELETE_SCENARIO_SUCCESS_BY_PLACE](state: ScenarioState, scenario: Scenario) {
    state.scenarios = {
      data: state.scenarios.data.filter(
        (sc: Scenario) => sc.id !== scenario.id,
      ),
      loading: false,
      error: null,
    };
  },
  [DELETE_SCENARIO_FAILURE_BY_PLACE](state: ScenarioState, error: string) {
    state.scenarios = {
      ...state.scenarios,
      loading: false,
      error: error,
    };
  },
};
